import { Component, OnInit, Input } from '@angular/core';
import { Production, VOD } from 'models';
import { ApiTopicItem, ApiTopic } from 'api';
import { ApiFullTopicItem } from 'api/model/FullTopicItem';

@Component({
  selector: 'tyt-topic-feed-item',
  templateUrl: './topic-feed-item.component.html',
  styleUrls: ['./topic-feed-item.component.scss']
})
export class TopicFeedItemComponent {

  constructor() { }

  @Input() 
  public topicItem : ApiFullTopicItem;

  @Input()
  audienceType : string;

  @Input()
  sessions = {};

  get spotIdentifier() {
    if (!this.topicItem)
      return null;

    if (this.topicItem.vod)
      return `vod_${this.topicItem.vod.id}`;
    else if (this.topicItem.article)
      return `article_${this.topicItem.article.id}`;
      
    return null;
  }
  get isUnlocked() {
    if (this.topicItem.vod) {
      if (!this.topicItem.vod.unlock_premium)
        return false;

      let dateString = this.topicItem.vod.unlock_premium_expiration;
      if (!dateString)
        return true;

      let date = new Date(dateString);
      return (date.getTime() > Date.now());
    }

    return false;
  }

  get isPremium() {
    if (this.topicItem.vod)
      return this.topicItem.vod.is_premium;
    else if (this.topicItem.article)
      return this.topicItem.article.members_only;

    return false;
  }

  get vodType() {
    if (!this.topicItem || !this.topicItem.vod || !this.topicItem.production)
      return null;

    if (this.topicItem.production.full_length_vods.some(x => x.id === this.topicItem.vod.id))
      return 'episode';
    else 
      return 'clip';
  }

  get badgeType() {
    if (this.topicItem.type === 'vod') {
      return this.vodType;
    } else if (this.topicItem.type === 'article') {
      return 'article';
    }

    return 'clip';
  }

  @Input()
  topic : ApiTopic;

  get thumbnailUrl() {
    if (!this.topicItem)
      return null;

    if (this.topicItem.vod) {
      if (this.topicItem.vod.thumbnail_landscape1)
        return this.topicItem.vod.thumbnail_landscape1;
      
      if (this.topicItem.production)
        return this.topicItem.production.thumbnail_landscape1;

      if (this.topic)
        return this.topic.thumbnail_square;
      
      return null;
    } else if (this.topicItem.article) {
      return this.topicItem.article.lead_image;
    }
  }
  get linkUrl() {
    if (this.topicItem.type === 'vod') {
      if (this.topicItem.production) {
        let mode = 'clips';
        if (this.topicItem.production.full_length_vods.some(x => x.id === this.topicItem.vod.id)) {
          mode = 'episodes';
        }

        return `/watch/${this.topicItem.production.show.id}/${this.topicItem.production.id}/${mode}/${this.topicItem.vod.id}`;
      }
    } else if (this.topicItem.type === 'article') {
      return `/stories/${this.topicItem.article.franchise.id}/${this.topicItem.article.id}`;
    }

    return '/';
  }
}
